import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import QuestionGroupsTable, {
  QUESTION_GROUP_COLUMNS, QUESTION_GROUP_CARDS, QUESTION_GROUP_MIN_TABLE_WIDTH
} from 'components/Tables/QuestionGroups';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'questionGroupStore') @observer
class QuestionGroupIndexPage extends Component {
  @observable visible = true;

  render() {
    let content;
    let {
      questionGroupStore,
      questionGroupStore: {
        groups: {
          isLoading,
          isError
        }
      }, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={QUESTION_GROUP_COLUMNS}
          cards={QUESTION_GROUP_CARDS}
          minTableWidth={QUESTION_GROUP_MIN_TABLE_WIDTH}
          noun="question groups"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="question groups" onRetry={() => questionGroupStore.loadQuestionGroups()} />;
    }
    if (!isError && !isLoading) {
      content = <QuestionGroupsTable />
    }
    return (
      <div>
        <Helmet>
          <title>Question Groups | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.QuestionGroupSearch key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default QuestionGroupIndexPage;